import React, { Component } from 'react'
import '../Classic/index.less'

export default class index extends Component {
  render() {
    return (
      <div>
        <div className="ludo-rule-content">
          <div className="ludo-rule-items">
            <div className="ludo-rule-content-title">MOVING OUT OF NEST</div>
            <div className="ludo-rule-content-pic">
              <img src="/img/ludo/rule1.png" alt="" />
            </div>
            <div className="ludo-rule-content-desc">
              3
            </div>
          </div>
          <div className="ludo-rule-items">
            <div className="ludo-rule-content-title">MOVING OUT OF NEST</div>
            <div className="ludo-rule-content-pic">
              <img src="/img/ludo/rule1.png" alt="" />
            </div>
            <div className="ludo-rule-content-desc">
              3
            </div>
          </div>
        </div>
        <div className="ludo-rule-desc">
          WINNING  THE  GAME
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/ludo/ludorule/Quick/index.js